export default "__VITE_ASSET__a577ea8d__"